import { Avatar, Card, Icon, showToast, Text } from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import { ActionsDropdown } from "../ActionsDropdown";
import { StatusTag } from "../StatusTag";

interface Props {
  name: string;
  email: string;
  isActive: boolean;
  refreshUser: () => void;
}
export function UserDetailsHeadingCard({
  name,
  email,
  isActive,
  refreshUser,
}: Props) {
  const { t } = useTranslation();
  const { userId } = useParams();
  const copyEmailToClipboard = () => {
    if (email) {
      navigator.clipboard.writeText(email);
      showToast(t("Copied"));
    }
  };
  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      copyEmailToClipboard();
    }
  };

  return (
    <Card className={styles.card} testID="user-details-heading-card">
      <div className={styles.container}>
        <div className={styles.userDetailsContainer}>
          <Avatar name={name || email} />
          <div className={styles.userDetails}>
            <div className={styles.userName}>
              <Text style="card/title-large" testID="user-details-name">
                {name}
              </Text>
              <StatusTag isActive={isActive} />
            </div>
            <div
              className={css(styles.email)}
              onClick={copyEmailToClipboard}
              onKeyDown={handleKeyDown}
              role="presentation"
            >
              <Text
                style="global/body-secondary"
                color="text-weak"
                testID="user-details-email"
              >
                {email}
              </Text>
              <Icon name="content_copy" size="space-3-5" />
            </div>
          </div>
        </div>
        <ActionsDropdown
          id={userId || ""}
          name={name || email}
          refreshUser={refreshUser}
          isActive={isActive}
        />
      </div>
    </Card>
  );
}

const styles = {
  card: css({
    padding: "var(--space-4)",
    display: "flex",
    flexDirection: "column",
    gap: "var(--space-4)",
    borderRadius: "var(--border-radius-3)",
  }),
  container: css({
    display: "flex",
    justifyContent: "space-between",
  }),
  userDetailsContainer: css({
    display: "flex",
    alignItems: "center",
    gap: "var(--space-2)",
  }),
  userDetails: css({
    display: "flex",
    flexDirection: "column",
    textAlign: "left",
  }),
  userName: css({
    display: "flex",
    gap: "var(--space-2)",
    alignItems: "center",
  }),
  email: css({
    display: "flex",
    cursor: "pointer",
    gap: "var(--space-1)",
    alignItems: "center",
  }),
};
